import { SingleSelectDropdown } from "./Single";
import { MultipleSelectDropdown } from "./Multiple";
import { ElasticSelectDropdown } from "./Elastic";

export const SelectDropdown = {
  Single: SingleSelectDropdown,
  Multiple: MultipleSelectDropdown,
  Elastic: ElasticSelectDropdown,
};
